import React, { Component } from 'react';
import { ModalRoot, ModalCard, ModalPage } from '@vkontakte/vkui';
import { connect } from 'react-redux';
import { setModal } from "../store/globals/actions";
import { push } from "react-router-redux";
import {vkTime} from "../services/_functions";

class ModalInfoCard extends Component {

    closeModal = () => {
        this.props.dispatch(setModal(null));
    };

    openRefund = () => {
        this.props.dispatch(push('/refund'));
        this.closeModal();
    };

    render() {
        const payedHtml =
            <div className="modal-info-text">Оплачено: <div className="modal-info-sum">{ this.props.paySum } ₽</div><div className="modal-info-date">{ this.props.payDate }</div></div>;
        const refundedHtml = [];
        if (this.props.allRefunds !== '') {
            refundedHtml.push(<div className="modal-info-text w-100" style={{ marginBottom: -12 }}>Возвраты:</div>);
            const refundsArr = this.props.allRefunds.split('|');
            for (let i = 0; i < refundsArr.length - 1; i++) {
                const sum = refundsArr[i].split(';')[0];
                const date = refundsArr[i].split(';')[1];
                refundedHtml.push(<div className="modal-info-text w-100"><div className="modal-info-sum">{ sum } ₽</div><div className="modal-info-date">{ vkTime(date) }</div></div>);
            }
        }

        const childrenHtml = +this.props.refundSum > 0 ? <div className="modal-info-flex">{ payedHtml } <div>{ refundedHtml }</div></div> : payedHtml;
        const action = +this.props.refundSum === +this.props.paySum ? '' : [{ title: 'Возврат', type: 'primary', action: this.openRefund }];

        return (
            <ModalRoot activeModal={ this.props.modal }>
                <ModalCard
                    id={ 'modal-info' }
                    onClose={ this.closeModal }
                    title={ this.props.fio }
                    actions={ action }
                    children={ childrenHtml }
                />
            </ModalRoot>
        )
    };
}

function mapStateToProps(state) {
    return {
        modal: state.globals.modal,
        fio: state.modal.fio,
        paySum: state.modal.paySum,
        payDate: state.modal.payDate,
        refundSum: state.modal.refundSum,
        refundDate: state.modal.refundDate,
        allRefunds: state.modal.allRefunds,
    };
}

export default connect(mapStateToProps)(ModalInfoCard);


// WEBPACK FOOTER //
// ./src/js/components/ModalInfoCard.js